import { faSearch, faXmark } from "@fortawesome/pro-solid-svg-icons";

import { Icon, IconButton, InputAdornment, TextField } from "../ui-v2";

type SearchInputFieldProps = {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
};

export const SearchInputField = ({
  value,
  onChange,
  onClear,
  placeholder = "Search by name or prompt...",
}: SearchInputFieldProps) => (
  <TextField
    variant="outlined"
    value={value}
    onChange={(e) => onChange(e.target.value)}
    size="small"
    sx={{
      width: 240,
    }}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Icon size="small" icon={faSearch} />
        </InputAdornment>
      ),
      placeholder,
      endAdornment: value.length ? (
        <InputAdornment position="end">
          <IconButton
            rounded
            aria-label="Clear search"
            variant="quaternary"
            onClick={() => onClear()}
          >
            <Icon icon={faXmark} size="small" />
          </IconButton>
        </InputAdornment>
      ) : null,
    }}
  />
);
